<cb-dialog class="flex-col" dialogHeading="{{ modeString }} Default Installer">
    <form class="flex-col flex" #form="ngForm">
        @if (isAdd()) {
            <cb-select
                [required]="true"
                name="selectedTradeTypeId"
                label="Trade Type"
                [(ngModel)]="selectedTradeTypeId"
                (change)="selectedTradeTypeChange()"
                [options]="availableTrades"
            >
            </cb-select>
        }
        @if (isEdit()) {
            <cb-display-value-new label="Trade Type" [value]="item?.tradeType?.label">
            </cb-display-value-new>
        }
        <cb-business-accounts-input-find-cards
            label="Business Account"
            [(ngModel)]="selectedSupplier"
            name="selectedSupplier"
            [text]="selectedSupplier?.tradingName"
            [disabled]="false"
            [searchParams]="businessAccountSearchParams"
            [required]="true"
            [canCreate]="false"
            (change)="changeSupplier()"
        >
        </cb-business-accounts-input-find-cards>
        @if (invalidSupplier) {
            <div class="flex-row">
                <mat-card class="cb-error-card">
                    <mat-card-content
                        >No Installer contact has been set up for this business account at this
                        location.</mat-card-content
                    >
                </mat-card>
            </div>
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            [disabled]="isSaveDisabled()"
            (cbClick)="save()"
            [clickLimit]="1"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
